// Central content / constants for StudyPoland
export const BRAND = {
  name: "StudyPoland",
  nameAlt: "studypoland.info",
  tagline: "Study in Poland, with clarity.",
  whatsapp: "+48510555499",
  whatsappDisplay: "+48 510 555 499",
  email: "info@studypoland.info",
  expertName: "Krzysztof Szymański",
  expertTitle: "International Students Advisor · 15+ Years",
};

export const SOCIAL = {
  facebook: "https://www.facebook.com/StudyPoland.Info",
  tiktok: "https://www.tiktok.com/@krzysztof_szymanski",
};

export const LANGUAGECERT = {
  registerUrl: "https://www.languagecert.org/",
  otherExamsUrl: "https://languagecert.codes",
  discountCode: "217C68",
  guidePdfUrl: `${process.env.REACT_APP_BACKEND_URL}/api/english-exam/guide`,
};

export const ENTRY_EXAMS = {
  coursesUrl: "https://studyinpoland.gumroad.com",
  subjects: [
    {
      key: "math",
      subject: "Mathematics",
      forWhom: "Engineering & technical programs",
      summary:
        "Comprehensive prep for the math sections used by Polish engineering, IT and technical Bachelor's entrance exams.",
      url: "https://studyinpoland.gumroad.com/l/mathexamprep",
    },
    {
      key: "biology",
      subject: "Biology",
      forWhom: "Medicine · Dentistry · Pharmacy · Veterinary Medicine",
      summary:
        "Core biology topics, sample questions and exam-style walkthroughs aligned to medical-program entrance tests.",
      url: "https://studyinpoland.gumroad.com/l/biolexamprep",
    },
    {
      key: "chemistry",
      subject: "Chemistry",
      forWhom: "Medicine · Dentistry · Pharmacy · Veterinary Medicine",
      summary:
        "Organic, inorganic and general chemistry refreshers structured around what Polish medical entrance exams actually test.",
      url: "https://studyinpoland.gumroad.com/l/chemexamprep",
    },
  ],
};

// Setmore booking URLs.
// To deep-link a specific service, replace the value with a service-specific
// Setmore URL e.g. `${BOOKING_GENERAL}/services/<service-id>` or
// `${BOOKING_GENERAL}/bookappointment?step=service&serviceId=<id>`.
export const BOOKING_GENERAL = "https://studyinpoland.setmore.com";
export const BOOKING_URLS = {
  general: BOOKING_GENERAL,
  bachelor: BOOKING_GENERAL,
  master: BOOKING_GENERAL,
  medicine: BOOKING_GENERAL,
  dentistry: BOOKING_GENERAL,
  phd: BOOKING_GENERAL,
  visa: BOOKING_GENERAL,
  premium: BOOKING_GENERAL,
};

export const CITIES = [
  "Warsaw",
  "Kraków",
  "Poznań",
  "Wrocław",
  "Gdańsk",
  "Lublin",
  "Katowice",
  "Rzeszów",
  "Toruń",
];

export const WHATSAPP_LINK = `https://wa.me/${BRAND.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(
  "Hi! I'd like to ask about studying in Poland."
)}`;

export const IMG = {
  // Krzysztof — real photos
  krzAdvising:
    "https://customer-assets.emergentagent.com/job_poland-pathway-hub/artifacts/tpk7rcf1_ChatGPT%20Image%20May%2017%2C%202026%20at%2012_19_11%20PM%20%287%29.png",
  krzWithFlag:
    "https://customer-assets.emergentagent.com/job_poland-pathway-hub/artifacts/9x5qvzec_ChatGPT%20Image%20May%2017%2C%202026%20at%2012_19_12%20PM%20%288%29.png",
  krzWalking:
    "https://customer-assets.emergentagent.com/job_poland-pathway-hub/artifacts/0j5jr1nf_ChatGPT%20Image%20May%2017%2C%202026%20at%2012_19_12%20PM%20%289%29.png",
  krzAirportLuggage:
    "https://customer-assets.emergentagent.com/job_poland-pathway-hub/artifacts/feslj7qt_ChatGPT%20Image%20May%2017%2C%202026%20at%2012_11_52%20PM%20%2810%29.png",
  krzAirportTalk:
    "https://customer-assets.emergentagent.com/job_poland-pathway-hub/artifacts/ao8a58by_ChatGPT%20Image%20May%2017%2C%202026%20at%2012_19_10%20PM%20%284%29.png",
  krzPortraitAirport:
    "https://customer-assets.emergentagent.com/job_poland-pathway-hub/artifacts/usjtxi8d_ChatGPT%20Image%20May%2017%2C%202026%20at%2012_11_50%20PM%20%282%29.png",

  // English-exam scene (student writing / certification context)
  englishExam:
    "https://images.pexels.com/photos/4144222/pexels-photo-4144222.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1100",

  // Aliases pointing at the real photos
  heroExpert:
    "https://customer-assets.emergentagent.com/job_poland-pathway-hub/artifacts/tpk7rcf1_ChatGPT%20Image%20May%2017%2C%202026%20at%2012_19_11%20PM%20%287%29.png",
  students:
    "https://customer-assets.emergentagent.com/job_poland-pathway-hub/artifacts/0j5jr1nf_ChatGPT%20Image%20May%2017%2C%202026%20at%2012_19_12%20PM%20%289%29.png",
  visa:
    "https://customer-assets.emergentagent.com/job_poland-pathway-hub/artifacts/feslj7qt_ChatGPT%20Image%20May%2017%2C%202026%20at%2012_11_52%20PM%20%2810%29.png",

  // Domain stock kept for sub-pages and gallery filler
  medical:
    "https://images.pexels.com/photos/3985154/pexels-photo-3985154.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1100",
  campus:
    "https://images.unsplash.com/photo-1717930851080-ee2293bd501d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  lecture:
    "https://images.pexels.com/photos/1595391/pexels-photo-1595391.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1100",
  library:
    "https://images.pexels.com/photos/1438072/pexels-photo-1438072.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1100",
  graduation:
    "https://images.pexels.com/photos/267885/pexels-photo-267885.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1100",
  krakow:
    "https://images.unsplash.com/photo-1519098901909-b1553a1190af?auto=format&fit=crop&w=1400&q=80",
  warsaw:
    "https://images.unsplash.com/photo-1607427293702-036933bbf746?auto=format&fit=crop&w=1400&q=80",
  research:
    "https://images.pexels.com/photos/3184325/pexels-photo-3184325.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1100",
  meeting:
    "https://images.pexels.com/photos/3184287/pexels-photo-3184287.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1100",
};

export const TRUST_STRIP = [
  "15+ years in Polish higher education",
  "Trusted by international students & families",
  "Admissions · Visa · Relocation",
  "Poland-focused expertise",
];

export const PATHWAYS = [
  {
    key: "bachelor",
    title: "Bachelor in Poland",
    blurb:
      "Find the right university, understand entry requirements, and prepare your admission path step by step.",
    href: "/bachelor",
    cta: "Explore Bachelor Path",
    image: "campus",
  },
  {
    key: "master",
    title: "Master in Poland",
    blurb:
      "Program matching, scholarships, documents and visa — a guided plan from application to arrival.",
    href: "/master",
    cta: "Explore Master Path",
    image: "library",
  },
  {
    key: "medicine",
    title: "Medicine & Dentistry",
    blurb:
      "Selective admissions, entrance exams and institution fit — premium, tailored guidance.",
    href: "/medicine-dentistry",
    cta: "Explore Premium Path",
    image: "medical",
    premium: true,
  },
  {
    key: "english",
    title: "English Exam",
    blurb:
      "LanguageCert ESOL and other accredited English tests Polish universities accept — register with our official discount.",
    href: "/english-exam",
    cta: "See English Requirements",
    image: "lecture",
  },
  {
    key: "phd",
    title: "PhD in Poland",
    blurb:
      "Supervisor search, program fit and research strategy for serious academic candidates.",
    href: "/phd",
    cta: "Explore PhD Guidance",
    image: "research",
    premium: true,
  },
];

export const TRUST_PILLARS = [
  {
    icon: "MapPin",
    title: "Poland-only expertise",
    body: "We focus on Poland — deeper guidance, more precise advice, no generic study-abroad clichés.",
  },
  {
    icon: "GraduationCap",
    title: "University insight, not guesswork",
    body: "We understand institutions, program positioning, and what different universities truly offer.",
  },
  {
    icon: "Compass",
    title: "Support beyond admission",
    body: "Documents, visa, arrival, accommodation — admission is just the beginning of the journey.",
  },
  {
    icon: "ShieldCheck",
    title: "Clarity in a complex process",
    body: "We simplify choices and reduce avoidable mistakes so you don't waste time on wrong applications.",
  },
  {
    icon: "Users",
    title: "Built for international students",
    body: "Real answers for the concerns, questions and risks international applicants actually face.",
  },
  {
    icon: "MessageCircle",
    title: "Human guidance, not internet answers",
    body: "Students and families receive direction based on real cases and fifteen years of experience.",
  },
];

export const SERVICE_LADDER = [
  {
    tier: "Start Here",
    badge: "Orientation",
    price: "Free · Low-cost",
    items: [
      "University & program guidance",
      "Admission requirements review",
      "Eligibility check",
      "Study in Poland consultation",
    ],
    cta: "Check My Eligibility",
    ctaHref: "#eligibility",
    accent: "light",
  },
  {
    tier: "Done-With-You",
    badge: "Most Popular",
    price: "Guided support",
    items: [
      "Application support",
      "Document preparation guidance",
      "Visa support",
      "Accommodation & relocation guidance",
    ],
    cta: "Book Expert Consultation",
    ctaHref: "#consultation",
    accent: "muted",
    featured: true,
  },
  {
    tier: "Premium · Complex",
    badge: "Tailored",
    price: "By application",
    items: [
      "Medicine & Dentistry strategy",
      "Premium admission strategy",
      "PhD / supervisor fit guidance",
      "Complex relocation & residence cases",
    ],
    cta: "Get a Tailored Strategy",
    ctaHref: "#premium",
    accent: "dark",
  },
];

export const PAIN_POINTS = [
  {
    worry: "Do I qualify for admission?",
    answer:
      "We review your background and identify realistic next steps — before you lose time on the wrong applications.",
  },
  {
    worry: "Which university should I choose?",
    answer:
      "We match programs to your field, budget and long-term plan, based on real insight into each institution.",
  },
  {
    worry: "How much will studying & living cost?",
    answer:
      "Transparent tuition ranges, living costs for Warsaw, Kraków and smaller cities, plus scholarship options.",
  },
  {
    worry: "What documents do I need?",
    answer:
      "A clear checklist by study level and nationality — translations, apostille, recognition, everything.",
  },
  {
    worry: "Can I manage the visa process correctly?",
    answer:
      "We walk you through appointments, documents and timelines so your visa doesn't become the weak link.",
  },
  {
    worry: "Is there a scholarship or lower-cost path?",
    answer:
      "We identify affordable universities, NAWA programs and funding routes that actually fit your profile.",
  },
];

export const PREMIUM_TRACKS = [
  {
    title: "Medicine in Poland",
    body: "Selective admissions, entrance exams, and highly-rated medical universities. You'll need more than a generic agent.",
    points: ["MD programs in English", "Entry exam preparation", "Institution fit strategy"],
    image: "medical",
    cta: "Discuss My Medicine Path",
  },
  {
    title: "Dentistry in Poland",
    body: "Dentistry programs are competitive and institution-specific. We help serious candidates position correctly.",
    points: ["DDS programs in English", "Portfolio & documents review", "Interview preparation"],
    image: "lecture",
    cta: "Discuss My Dentistry Path",
  },
  {
    title: "PhD in Poland",
    body: "Supervisor search, research fit and program strategy for research-oriented candidates.",
    points: ["Supervisor identification", "Proposal refinement", "Funding & stipend routes"],
    image: "research",
    cta: "Explore PhD Guidance",
  },
];

export const TESTIMONIALS = [
  {
    name: "Amira H.",
    role: "MSc Computer Science · Warsaw",
    quote:
      "I was overwhelmed by options. Within one call I had a clear shortlist, a visa plan, and a realistic budget. I stopped guessing.",
  },
  {
    name: "Omar K.",
    role: "Medicine · Poznań",
    quote:
      "Medicine admissions in Poland felt impossible from abroad. The advice was specific to each university — not generic.",
  },
  {
    name: "Family of R. P.",
    role: "Parent of Bachelor student",
    quote:
      "As parents, we needed someone to trust. The documents and the visa process were handled with calm and precision.",
  },
  {
    name: "Dr. L. Mensah",
    role: "PhD candidate · Kraków",
    quote:
      "The supervisor search alone was worth the consultation. I would not have found the right research fit on my own.",
  },
];

export const FAQ = [
  {
    q: "Can you help me choose the right university?",
    a: "Yes — that's one of the most valuable parts of our work. We match your background, field and budget to institutions that actually fit, rather than pushing whichever university is easiest.",
  },
  {
    q: "Can you help with visa procedures?",
    a: "Yes. We guide you through documents, appointments and timelines, and we flag the common mistakes that lead to delays or refusals.",
  },
  {
    q: "Do you work with Bachelor, Master and PhD students?",
    a: "Yes — all three levels, including Medicine, Dentistry and research PhDs. Each has a dedicated path because the requirements are very different.",
  },
  {
    q: "Can you help with Medicine and Dentistry applications?",
    a: "Yes, this is one of our premium tracks. These admissions are selective and highly institution-specific, so we build a tailored strategy.",
  },
  {
    q: "Do you support students after admission?",
    a: "Yes. Accommodation, arrival, residence card, opening a bank account, and early-life-in-Poland guidance — admission is just the start.",
  },
  {
    q: "How do I know if I qualify?",
    a: "Use the free Eligibility Check form. We review your profile and tell you honestly what's realistic, and where you'd be wasting time.",
  },
  {
    q: "Can I contact you before booking a full consultation?",
    a: "Absolutely — use WhatsApp or the contact form. Not every case needs a paid consultation, and we'll tell you when it doesn't.",
  },
];

export const PROOF_STATS = [
  { value: "15+", label: "Years with Polish higher education" },
  { value: "100+", label: "Universities I work with in Poland" },
  { value: "1,000s", label: "Students & families advised" },
];
